import React, {Fragment} from "react";
import {ReferenceArea} from "recharts";
import {LEVEL_COLORS} from "./levelColors";

export const RangeThresholdMarker = ({domains, threshold}) => {
  const [minValue, maxValue] = domains;
  const {level, min, max, within} = threshold;
  const color = LEVEL_COLORS[level.toLowerCase()];

  return (
    <Fragment>
      {within ? (
        <Fragment>
          {(max || max === 0) && (min || min === 0) && (
            <ReferenceArea
              fill={color}
              ifOverflow="hidden"
              stroke="none"
              y1={min}
              y2={max}
            />
          )}
        </Fragment>
      ) : (
        <Fragment>
          {(max || max === 0) && (
            <ReferenceArea
              fill={color}
              ifOverflow="hidden"
              stroke="none"
              y1={max}
              // Multiply by 2 because sometimes the max value does not touch the top of the chart
              y2={maxValue * 2}
            />
          )}
          {(min || min === 0) && (
            <ReferenceArea
              fill={color}
              ifOverflow="hidden"
              stroke="none"
              // extend the area to the bottom of the chart or to zero, whichever is lower
              y1={Math.min(minValue, 0)}
              y2={min}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
